import styled from 'styled-components';
import { Colors, Media } from 'enums';
import { Button } from 'view/atoms/Button';

export const StyledClearButton = styled(Button)`
  width: 92%;
  display: flex;
  align-self: flex-end;
  justify-content: space-between;
  align-items: start;
  cursor: pointer;
  user-select: none;
  margin-top: 10px;
  border-radius: 8px;
  transition: none;
  padding: 8px 12px !important;
  min-height: 40px !important;
  height: auto !important;

  background-color: ${Colors.background};
  &:hover {
    background-color: ${Colors.white};
  }

  @media ${Media.notebook} {
    width: 85%;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;
